import { render, staticRenderFns } from "./ViAssignAdhocFess.vue?vue&type=template&id=28f11902"
import script from "./ViAssignAdhocFess.vue?vue&type=script&lang=js"
export * from "./ViAssignAdhocFess.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports